import React from 'react';
import { WrappedFieldProps } from 'redux-form';

import { MaskedTextInput } from 'atoms';

interface IProps extends WrappedFieldProps {
  caption: string;
  required?: boolean;
  className?: string;
}

export const DateField = ({ input, meta: { touched, error }, required, caption, className }: IProps) => {
  const errorText = touched && error ? error : '';

  return (
    <MaskedTextInput
      mask="99.99.9999"
      type="primary"
      caption={caption}
      errorMsg={errorText}
      required={required}
      className={className}
      {...input}
    />
  );
};
